'use strict';

angular.module('app').directive('hideFilterDirective', function () {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs, ctrl) {
      var filters = $('.filters'),
          clicked = false;

      $('.filter-expand, #search-btn').click(function(){
        if (window.innerWidth < 767) {
          filters.slideToggle();
          $('.filter-expand').toggleClass('active');

          clicked = !clicked;
        }
      });

      $(window).resize(function() {
        if (window.innerWidth >= 767) {
          filters.show();
        } else {
          clicked ? filters.show() : filters.hide();
        }
      });
    }
  };
})
